import React from 'react';

import CheckableReviewCriterionRow from 'notebook/reviews/CheckableReviewCriterionRow';
import {ReviewSummary} from 'notebook/reviews/ReviewConstants';
import {ReviewCriteriaGroup, ReviewCriterionStatus} from 'notebook/reviews/ReviewCriteriaConstants';
import ReviewCriteriaGroupHeader from 'notebook/reviews/ReviewCriteriaGroupHeader';
import {Thunk} from 'redux-stores/Store';

interface CheckableReviewCriteriaGroupProps {
  review: ReviewSummary;
  reviewCriteriaGroup: ReviewCriteriaGroup;
  updateReviewCriterion: (criterionId: string, {status}: {status: ReviewCriterionStatus}) => Thunk<void>;
  enabled: boolean;
}

export default function CheckableReviewCriteriaGroup({
  review,
  reviewCriteriaGroup,
  updateReviewCriterion,
  enabled,
}: CheckableReviewCriteriaGroupProps): JSX.Element {
  const {name, reviewCriteria} = reviewCriteriaGroup;
  return (
    <div className="simpleDivTable u-spacing-bottom">
      <ReviewCriteriaGroupHeader renderGroupName={() => name} onAddCriterion={null} />
      {reviewCriteria.map((criterion) => (
        <CheckableReviewCriterionRow
          key={criterion.id}
          review={review}
          reviewCriterion={criterion}
          updateReviewCriterion={updateReviewCriterion}
          enabled={enabled}
        />
      ))}
    </div>
  );
}
